import {createSlice} from "@reduxjs/toolkit";

const initialState = {
  initialized: false,
  menuState: true,
  expiredModal: false,
  networkErrorModal: false,
  networkErrorModalError: null,

  token: {},

  projectId: null,

  config: {
    assistant: true,
    expirationDate: null,
    decimalSeparator: ",",
    thousandSeparator: " ",
    dateFormat: "",
    currencyMain: "EUR",
    portfolioCurrency: "EUR"
  },

  currencies: [],
  rates: {}
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    init: (state, action) => {
      state.initialized = true;

      state.projectId = action.payload.projectId;

      if (action.payload.token) {
        state.token = action.payload.token;
      }

      state.config.assistant = action.payload.assistant;
      state.config.expirationDate = action.payload.expirationDate;
      state.config.locale = action.payload.locale;
      state.config.decimalSeparator = action.payload.decimalSeparator;
      state.config.thousandSeparator = action.payload.thousandSeparator;
      state.config.currencyMain = action.payload.currencyMain;
      state.config.dateFormat = action.payload.dateFormat;
      state.config.defaultTransactionsPeriod = action.payload.defaultTransactionsPeriod;
      state.config.defaultTransactionsAccount = action.payload.defaultTransactionsAccount || null;
      state.config.featurePortfolioActive = action.payload.featurePortfolioActive;
      state.config.defaultPortfolioAccount = action.payload.defaultPortfolioAccount || null;
      state.config.defaultPortfolioTransactionCategory = action.payload.defaultPortfolioTransactionCategory || null;
      state.config.portfolioCurrency = action.payload.portfolioCurrency;
      state.config.featureCarsActive = action.payload.featureCarsActive;
      state.config.defaultCarsAccount = action.payload.defaultCarsAccount || null;
      state.config.defaultCarsTransactionCategory = action.payload.defaultCarsTransactionCategory || null;

      state.currencies = action.payload.currencies;
      state.rates = {};

      state.currencies.forEach(c => state.rates[c.code] = c.rate);
    },

    toggleLeftMenu: state => {
      state.menuState = !state.menuState;
    },

    submitSettingsGeneral: (state, action) => {
      state.config.locale = action.payload.locale;
      state.config.decimalSeparator = action.payload.decimalSeparator;
      state.config.thousandSeparator = action.payload.thousandSeparator;
      state.config.currencyMain = action.payload.currencyMain;
      state.config.dateFormat = action.payload.dateFormat;
    },

    submitSettingsAccounts: (state, action) => {
      state.config.defaultTransactionsPeriod = action.payload.defaultTransactionsPeriod;
      state.config.defaultTransactionsAccount = action.payload.defaultTransactionsAccount || null;
    },

    submitSettingsPortfolio: (state, action) => {
      state.config.featurePortfolioActive = action.payload.featurePortfolioActive;
      state.config.defaultPortfolioAccount = action.payload.defaultPortfolioAccount || null;
      state.config.defaultPortfolioTransactionCategory = action.payload.defaultPortfolioTransactionCategory || null;
      state.config.portfolioCurrency = action.payload.portfolioCurrency;
    },

    submitSettingsCars: (state, action) => {
      state.config.featureCarsActive = action.payload.featureCarsActive;
      state.config.defaultCarsAccount = action.payload.defaultCarsAccount || null;
      state.config.defaultCarsTransactionCategory = action.payload.defaultCarsTransactionCategory || null;
    },

    updateSettings: (state, action) => {
      state.config.locale = action.payload.locale;
      state.config.assistant = action.payload.assistant;
      state.config.expirationDate = action.payload.expirationDate;
      state.config.decimalSeparator = action.payload.decimalSeparator;
      state.config.thousandSeparator = action.payload.thousandSeparator;
      state.config.currencyMain = action.payload.currencyMain;
      state.config.dateFormat = action.payload.dateFormat;
      state.config.defaultTransactionsPeriod = action.payload.defaultTransactionsPeriod;
      state.config.defaultTransactionsAccount = action.payload.defaultTransactionsAccount || null;
      state.config.featurePortfolioActive = action.payload.featurePortfolioActive;
      state.config.defaultPortfolioAccount = action.payload.defaultPortfolioAccount || null;
      state.config.defaultPortfolioTransactionCategory = action.payload.defaultPortfolioTransactionCategory || null;
      state.config.portfolioCurrency = action.payload.portfolioCurrency;
      state.config.featureCarsActive = action.payload.featureCarsActive;
      state.config.defaultCarsAccount = action.payload.defaultCarsAccount || null;
      state.config.defaultCarsTransactionCategory = action.payload.defaultCarsTransactionCategory || null;
    },

    updateRates: (state, action) => {
      state.rates = action.payload;
    },

    updateToken: (state, action) => {
      state.token = action.payload.token
    },

    toggleExpiredModal: state => {
      state.expiredModal = !state.expiredModal;
    },

    toggleNetworkErrorModal: (state, action) => {
      state.networkErrorModal = !state.networkErrorModal;
      state.networkErrorModalError = action.payload;
    },

    completeAssistant: state => {
      state.config.assistant = false;
    },

    togglePortfolioFeature: (state, action) => {
      state.config.featurePortfolioActive = action.payload
    },

    toggleCarsFeature: (state, action) => {
      state.config.featureCarsActive = action.payload;
    }
  }
});

export const {
  init: rxInit,
  toggleLeftMenu: rxToggleLeftMenu,
  submitSettingsGeneral: rxSubmitSettingsGeneral,
  submitSettingsAccounts: rxSubmitSettingsAccounts,
  submitSettingsPortfolio: rxSubmitSettingsPortfolio,
  submitSettingsCars: rxSubmitSettingsCars,
  updateSettings: rxUpdateSettings,
  updateRates: rxUpdateRates,
  updateToken: rxUpdateToken,
  toggleExpiredModal: rxToggleExpiredModal,
  toggleNetworkErrorModal: rxToggleNetworkErrorModal,
  completeAssistant: rxCompleteAssistant,
  toggleCarsFeature: rxToggleCarsFeature,
  togglePortfolioFeature: rxTogglePortfolioFeature
} = appSlice.actions;

export const appConfigSelector = state => state.app.config;
export const appRatesSelector = state => state.app.rates;
export const appCurrenciesSelector = state => state.app.currencies;

export default appSlice.reducer;
